module.exports = __webpack_public_path__ + "img/7151cfc4-086a-4db2-aefa-6c4dd4adf16c.3716e1cc.png";